import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { damageTypes } from "../../../constants/options";
import { formTypes, damageKeys } from "../../../constants/keys";

function IncidentDetails({
  lossCauses,
  fields,
  utilities,
}) {
  const typeOfClaim = useSelector((state) => state.anonymousForms.typeOfClaim);
  const [theCauses, setTheCauses] = useState(lossCauses);
  const {
    createTextArea,
    createCustomLabelSelect,
    createSearchableSelect,
    handleFieldChange
  } = utilities;

  useEffect(() => {
    if (typeOfClaim === formTypes.Auto || typeOfClaim === formTypes.Garage || typeOfClaim === formTypes.Vehicle) {
      setTheCauses([...lossCauses.filter((cause) => cause.Auto)]);
    } else if (typeOfClaim === formTypes.Liability) {
      setTheCauses([...lossCauses.filter((cause) => cause.Liability)]);
    } else if (typeOfClaim === formTypes.Property) {
      setTheCauses([...lossCauses.filter((cause) => cause.Property)]);
    } else if (typeOfClaim === formTypes.Home) {
      if (damageTypes.find(type => type.label === fields.damageType?.value).value === damageKeys.Property) {
        setTheCauses([...lossCauses.filter((cause) => cause.Property)]);
      } else {
        setTheCauses([...lossCauses.filter((cause) => cause.HomeLiability)]);
      }
    }
  }, [typeOfClaim, fields.damageType?.value]);

  useEffect(() => {
    if (
      theCauses?.length > 0 &&
      fields.lossCause.value &&
      !theCauses.find((cause) => cause.FullText === fields.lossCause.value)
    ) {
      handleFieldChange("", fields.lossCause, true, null);
    }
  }, [theCauses]);//clearing loss cause if invalid when cause list changes

  return (
    <div>
      <PageWrapper legendInfo="Incident Details:" required="true">
        <div className={Styles.textAreaContainer}
              style={{
              paddingTop: "1rem",
              width: "80%",
              alignSelf: "center",
              alignItems: "flex-start",
            }}>
          {createTextArea(
            fields.whatHappen,
            "100%",
            true,
            Styles.detailsText,
            { punctuate: "." })}
        </div> 

        {typeOfClaim === formTypes.Home && (
          <div
            className={Styles.textAreaContainer}
            style={{
              paddingTop: "1rem",
              width: "80%",
              alignSelf: "center",
              alignItems: "flex-start",
            }}
          >
            {createCustomLabelSelect(fields.damageType, damageTypes.map(item => item.label), Styles.anonSelect, Styles.anonLabel)}
          </div>
        )}

        {(fields.damageType?.value || typeOfClaim !== formTypes.Home) && (
          <div
            className={Styles.textAreaContainer}
            style={{
              paddingTop: "1rem",
              width: "80%",
              alignSelf: "center",
              alignItems: "flex-start",
            }}
          >
            {createSearchableSelect(
              fields.lossCause,
              "100%",
              theCauses.map(item => item.FullText),
              false,
              "",
              false,
              true
            )}
          </div>
        )}
      </PageWrapper>
    </div>
  );
}

export default IncidentDetails;
